export const SHOW_ABAD = 'showAbad';
export const SYNTHETIC_TEST_INDICATOR = 'syntheticTest';
export const QUERY_PARAMETER_MANAGER_STORAGE_KEY = 'zhl-query-parameters';
export const NOT_FOUND_REDIRECT = 'notFoundRedirect';

export enum NotFoundRedirect {
    HOME_PAGE = 'homePage', // Redirect users without a dashboard to the home loans landing page
    NOT_FOUND = 'notFound', // Redirect users without a dashboard to a "not found" page
}

export const EXCESS_AMPERSAND_REGEX = /&(?!\w)/g;
